import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import EntryData from '../../services/entry-service';
import SocioData from '../../services/socio-service';
import PeopleData from '../../services/people-service';
import './entries.css';
var apiService = require('../../services/api-service');
var apigClientFactory = require('aws-api-gateway-client').default;


export class SubmitEntryUnauthenticatedForm extends React.Component {

  password;

  constructor() {
    super()
    this.state = {}
  }

  componentDidMount() {
    const { accessToken } = this.props;
    this.setState({
      accessToken
    })
  }

  peopleList = {};
  includedPeople = [];
  favourite = null;

  handlePersonCheck = event => {
    if( event.target.checked )
      this.includedPeople.push(event.target.name);
    else{
      var index = this.includedPeople.indexOf(event.target.name);
      this.includedPeople.splice(index, 1);
    }
  }

  handleSociogramSelect = async (event) => {
    var getPeople = SubmitEntryUnauthenticatedForm.getSociogramById(event.target.value, this.state.socio);
    var people = getPeople[0].people;
    const { accessToken } = this.state;
    const data = await PeopleData.queryData(people, accessToken) 
    console.log("Query: " + JSON.stringify(data));
    this.setState({ 
      people: data,
      selectedOption: data[0].id
    });
    const entryData = await EntryData.getEntriesBySociogram(event.target.value, accessToken);
    console.log("Entries Query: " + JSON.stringify(entryData));
    this.setState({ 
      entries: entryData
    });
    return false;
  }

  static sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  handlePersonSelect = event => {
    //reset select count
    this.includedPeople = [];
    console.log("SELECTED: " + event.target.value);
    this.setState({ 
      selectedPerson: event.target.value
    });
    // auto select the second radio favourite box if the first user is selected
    //alert(JSON.stringify(this.state.people));
    console.log(event.target.value + " - " + this.state.people[0].id);
    if( event.target.value == 0 ){
      this.setState({ 
        selectedOption: this.state.people[1].id
      });
    }else{
      this.setState({ 
        selectedOption: this.state.people[0].id
      })
    }
    
    var x = document.getElementsByClassName("checkbox");
    for(var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }
    return false;
  }

  static getSociogramById(id,data) {
    return data.filter(
      function(data){ return data.id == id }
    );
  }


  static getIdByUser(entryArray, id){
    console.log("Search Array For: " + JSON.stringify(entryArray) + " FOR: " + id);
    for( var i = 0; i < entryArray.length; i++ )
      if( entryArray[i].person == id )
        return entryArray[i].id;
  }

  handleSubmit = event => {
    event.preventDefault();
    var formData = {};
    formData.socioData = this.includedPeople;
    formData.socioFavourite = this.state.selectedOption;
    formData.password = this.state.password;

    var config = { invokeUrl: apiService.baseURL }
    var apigClient = apigClientFactory.newClient(config);
    // console.log("People: " + JSON.stringify(this.state.people));
    // console.log("Raw selected person: " + this.state.selectedPerson);
    // console.log("Selected Person: " + SubmitEntryForm.getIdByUser(this.state.entries, this.state.people[this.state.selectedPerson].id) );
    var params = {
      //selectedPerson: SubmitEntryForm.getIdByUser(this.state.entries, this.state.selectedPerson)
      selectedPerson: SubmitEntryUnauthenticatedForm.getIdByUser(this.state.entries, this.state.people[this.state.selectedPerson].id),
      account: this.props.match.params.account,
      sociogram: this.props.match.params.sociogram
    }
    var pathTemplate = '/api/sociogramnoauth/entry/{selectedPerson}/{account}/{sociogram}'
    var method = 'PUT';  
    var additionalParams = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem('access_token')
      }
    };
    const peopleList = this.peopleList;
    var self = this;
    apigClient.invokeApi(params, pathTemplate, method, additionalParams, formData)
    .then(function(result){
      alert("Successfully Updated Entry");
      self.includedPeople = [];
      return;
    }).catch( function(result){
      console.log("Fail - " + result);
      return;
    });
  }

  

  handlePersonCheck = event => {
    if( event.target.checked ){
      this.includedPeople.push(event.target.value);
    } else {
      var index = this.includedPeople.indexOf(event.target.value);
      this.includedPeople.splice(index, 1);
    }
  }


  handleOptionChange = changeEvent => {
    this.setState({
      selectedOption: changeEvent.target.value
    });
  };

  setPassword = event => {
    event.preventDefault();
    const data = new FormData(event.target);
    this.setState({
      password: data.get('password'),
    });
    var id = this.props.match.params.sociogram;
    var account = this.props.match.params.account;
    const self = this;
    // alertalert(id + " - " + data.get('password'));
    SocioData.getSociogramUnauthenticated(id, account, data.get('password'), function (err,data) {
      if( err ){
        // alert("error");
        // alert(JSON.stringify(err));
        self.setState({ 
          error: true 
        });
        return;
      }else{
        console.log("Data: " + JSON.stringify(data));
        // alert(JSON.stringify(data.people));
        var people = [];
        Object.keys(data.people).forEach(function(k){
          people.push(data.people[k]);
        });
        self.setState({ 
          socio: data.sociogram,
          people: PeopleData.sortByKey(people, "surname"),
          entries: SubmitEntryUnauthenticatedForm.sortByKey(data.entries, "surname"),
          selectedOption: null,
        });
        return;
      }
    });
  }
  
  

  render() {

    let socios = [];
    let people = [];
    let selectPeople = null;
    selectPeople = [];

    if( !this.state.password ) {
      return(<div>
        <form className="form-horizontal" onSubmit={this.setPassword}>
          <p>Enter Password to continue</p>
          <input type="password" name="password" id="password" />
          <button
            type="submit"
            className="btn btn-primary btn-block contact">
            Continue
          </button>
        </form>
      </div>);
    }
    
    if( !this.state.socio )
      return (<div>Waiting for data to finish loading...</div>);

    for( var i = 0; i < this.state.socio.length; i++){
        socios.push(<option value={this.state.socio[i].id}>{this.state.socio[i].name}</option>)
    }

    if( this.state.people ){
      var self = this;
      Object.keys(self.state.people).forEach(function(k){
        people.push(<option value={k}>{self.state.people[k].givenName} {self.state.people[k].surname}</option>)
      });
    }

    if( this.state.people && this.state.selectedPerson ){
      var self = this;
      for(var personToSelect = 0; personToSelect < this.state.people.length; personToSelect++ ){
        if( personToSelect != self.state.selectedPerson )
          selectPeople.push(<tr>
            <td>
              <input 
                type="checkbox"
                class={"checkbox"}
                value={this.state.people[personToSelect].id}
                onChange={self.handlePersonCheck} />
            </td>
            <td>
              {this.state.people[personToSelect].surname}
            </td>
            <td>
              {this.state.people[personToSelect].givenName}
            </td>
            <td>
              <input type="radio" value={this.state.people[personToSelect].id} name="favourite" 
                checked={self.state.selectedOption === this.state.people[personToSelect].id } 
                onChange={self.handleOptionChange} /> 
              Select as favourite. 
            </td>
          </tr>);
      };
    }

    return (
      <div>
        <h1>Submit Sociogram Entry</h1>
        <form className="form-horizontal" onSubmit={this.handleSubmit}>
          <div>
            Who are you:
            <select onChange={this.handlePersonSelect}>
              <option></option>
              {people}
            </select>
          </div>
          <hr />
          <div>
            <div>Select connections:</div>
            <table>
              <tr>
                <td></td>
                <td><b>Last Name</b></td>
                <td><b>First Name</b></td>
                <td><b>Select as favourite</b></td>
              </tr>
              {selectPeople}
            </table>  
          </div>
          <div className="col-md-12">
            <button
              type="submit"
              className="btn btn-primary btn-block contact">
              Submit Entry
            </button>
          </div>
        </form>
      </div>
    );
  }
}


